import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';
import type { MessageHistory } from '../lib/database.types';

export function useMessages() {
  const { user, userProfile } = useAuth();
  const [messages, setMessages] = useState<MessageHistory[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchMessages();
    }
  }, [user]);

  const fetchMessages = async () => {
    if (!user) return;

    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('message_history')
        .select('*')
        .eq('user_id', user.id)
        .order('sent_at', { ascending: false })
        .limit(50);

      if (error) throw error;
      setMessages(data || []);
    } catch (err) {
      console.error('Error fetching messages:', err);
    } finally {
      setLoading(false);
    }
  };

  const sendTestMessage = async () => {
    if (!user) return { error: new Error('No user logged in') };

    try {
      await fetch(`https://charlieosmond.app.n8n.cloud/webhook${import.meta.env.DEV ? "-test" : ""}/send-test-message`, {
        method: "POST",
        body: JSON.stringify({
          phoneNumber: userProfile?.phone_number,
          fullName: userProfile?.full_name,
        }),
      })

    } catch (err) {
      return { error: err };
    }
  };

  return {
    messages,
    loading,
    sendTestMessage,
    refetch: fetchMessages,
  };
}